export default "__VITE_ASSET__DC67POLo__"